import {
  PERSON_STATUSES as SharedPERSON_STATUSES,
  PERSON_ACTIVE_LIKE_STATUSES as SharedPERSON_ACTIVE_LIKE_STATUSES
} from "shared/dist/types/Person";

import type {
  Person as SharedPerson,
  PersonStatus
} from "shared/dist/types/Person";

export { PersonStatus};
export const PERSON_STATUSES = SharedPERSON_STATUSES;
export const PERSON_ACTIVE_LIKE_STATUSES = SharedPERSON_ACTIVE_LIKE_STATUSES;

export default interface Person extends SharedPerson {
  ghinIndex?: number | string; // Available when synthesized from Membership data
}
